fieldset {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
}

fieldset > label {
	width: 24rem;
}

fieldset > label > input {
	width: 100%;
}

.dataList > div {
	padding: 0 !important;
	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.dataList > div > label {
	width: 24rem;
	font-weight: bold;
}

.date {
	width: 100%;
}
.gender > select {
	width: 100%;
	max-width: 24rem;
	border-radius: var(--rounded);
	background-color: var(--depth2);
	padding: 0.5rem;
}
.error {
	color: var(--textError);
}
.previewCard {
	display: none;
}

@media screen and (max-width: 500px) {
	.input > input {
		width: 12rem;

		min-width: 90%;
	}
}
.closeOverlay > h1 {
	display: none;
}

@media screen and (max-width: 1350px) {
	.box.registerCard {
		display: none !important;
	}
	.registerCardOverlay {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: absolute;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 70%);
		z-index: 90000;
	}
	.registerCardOverlay > h1 {
		display: block;
		padding: 5rem;
		opacity: 1;
		color: var(--textSecondary);
	}
	.closeOverlay {
		display: none;
	}
	.previewCard {
		display: block;
		border-radius: var(--roundedBig);
		background-color: var(--primary);
		position: absolute;
		top: 1rem;
		right: 1rem;
		scale: 0.8;
		padding: 0.2rem;
	}
	.previewCard svg {
		fill: var(--textSecondary);
		stroke: var(--textSecondary);
	}
}
